import { Skeleton, Stack, Typography } from '@mui/material'
import type { BillType } from '../../../all-types/bill'
import { OrderCard } from './OrderCard'
import Box from '@mui/material/Box'

type orderBoxProps = {
  loading: boolean
  data: BillType[]
  setSelectedBill: (bill: BillType) => void
  selectedBillId?: string | number
}

const getBillId = (b: any): string =>
  String(b?._id ?? b?.id ?? b?.billNo ?? `${b?.billNo ?? ''}-${b?.createdAt ?? b?.date ?? ''}`)

function OrderBox({
  loading,
  data,
  setSelectedBill,
  selectedBillId,
}: orderBoxProps) {
  return (
    <Box
      sx={{
        minWidth: { xs: 300, sm: 400, lg: 420 },
        maxHeight: { xs: '55dvh', md: '72dvh' },
        overflowY: 'scroll',
        py: 0.5,
        pr: 1,
        pl: 0.5,
      }}
    >
      {loading && (
        <Box>
          <Stack spacing={2}>
            <Skeleton variant="rounded" width="100%" height={80} />
            <Skeleton variant="rounded" width="100%" height={80} />
            <Skeleton variant="rounded" width="100%" height={80} />
            <Skeleton variant="rounded" width="100%" height={80} />
          </Stack>
        </Box>
      )}
      {!loading && data.length === 0 && (
        <Typography display="flex" pl={2} py={5} color="gray">
          No billing records available.
        </Typography>
      )}
      {!loading && data.length > 0 && (
        <Box sx={{ display: 'flex', borderRadius: '10px', gap: 1, flexDirection: 'column' }}>
          {data.map((bill) => {
            const id = getBillId(bill)
            return (
              <OrderCard
                key={id}                         // FIX: stable key
                bill={bill}
                selected={id === selectedBillId}  // FIX: selected compares same stable ID
                onSelect={() => setSelectedBill(bill)}
              />
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export { OrderBox }
